export default __webpack_public_path__ + "assets/d2f148ed57b904f48b9d6d51b401692d.png";